import {
  ambulanceServiceAssessorOption,
  buildMcaCapacityAssessmentFormSpecification,
  localTriageServiceAssessorOption,
  otherAssessorOption,
  railwayUseOfForceTypeOptions,
  reportingOfficerAssessorOption,
  type McaCapacityAssessmentFormData as CommonMcaCapacityAssessmentFormData,
} from "../common/mcaCapacityAssessment.js";

export const formSpecification = buildMcaCapacityAssessmentFormSpecification({
  assessingIndividualOptions: [
    reportingOfficerAssessorOption,
    ambulanceServiceAssessorOption,
    localTriageServiceAssessorOption,
    otherAssessorOption,
  ],
  useOfForceTypeOptions: railwayUseOfForceTypeOptions,
});

export type McaCapacityAssessmentFormData = CommonMcaCapacityAssessmentFormData;
